import { TaskRegistry, InputStep, Context } from '@things-factory/integration-base'
import { issueDataCollectionTask } from '../../controllers/issue-data-collection-task.js'
import i18next from 'i18next'

async function IssueCollectData(step: InputStep, context: Context) {
  const { logger, data, domain, user, lng } = context
  var {
    params: { dataset: dataSetId }
  } = step

  if (!dataSetId) {
    throw new Error(`no dataset found`)
  }

  const activityInstance = await issueDataCollectionTask(domain.id, dataSetId, {
    t: i18next.t,
    state: {
      domain,
      user,
      lng,
      tx: undefined
    }
  })

  return {
    data: activityInstance
  }
}

IssueCollectData.parameterSpec = [
  {
    type: 'entity-selector',
    name: 'dataset',
    label: 'data-set',
    property: {
      queryName: 'dataSets',
      valueKey: 'id'
    }
  }
]

IssueCollectData.connectorFree = true
IssueCollectData.help = 'dataset/task/issue-collect-data'

TaskRegistry.registerTaskHandler('issue-collect-data', IssueCollectData)
